<template>
    <div id="forgot-password">
        <component :is="component"></component>
    </div>
</template>

<script>
import ValuePage from '../../components/onboarding/forgot-password/forgot-email.vue'
import ResetPassword from '../../components/onboarding/forgot-password/reset-password.vue'
export default {
    components:{ValuePage,ResetPassword},
    computed:{
        component(){

            let page = this.$store.getters['user/getForgotPage']
            if(page == 0) return 'ValuePage'
            else if(page==1) return 'ResetPassword'
            else return 'ValuePage'
        }
    }
}
</script>

<style scoped>

</style>